import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { OrderProvider } from "@/context/OrderContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import { trackPageView } from "@/lib/analytics";
import OrderPage from "@/pages/OrderPage";
import LandingPage from "@/pages/LandingPage";
import OrderLookupPage from "@/pages/OrderLookupPage";
import ChooseDoorPage from "@/pages/ChooseDoorPage";
import MeasurementEntryPage from "@/pages/MeasurementEntryPage";
import ResumeOrderPage from "@/pages/ResumeOrderPage";
import ManageOrderPage from "@/pages/ManageOrderPage";
import PartsCatalogPage from "@/pages/PartsCatalogPage";
import PartsCartPage from "@/pages/PartsCartPage";
import PartsThankYouPage from "@/pages/PartsThankYouPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsPage from "@/pages/TermsPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminCatalog from "@/pages/admin/AdminCatalog";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminTemplates from "@/pages/admin/AdminTemplates";
import AdminDiscounts from "@/pages/admin/AdminDiscounts";
import AdminPromotions from "@/pages/admin/AdminPromotions";
import AdminGallery from "@/pages/admin/AdminGallery";
import { PromotionProvider } from "@/components/PromoBanner";

function PageViewTracker() {
  const loc = useLocation();
  useEffect(() => { trackPageView(loc.pathname + loc.search); }, [loc.pathname, loc.search]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <OrderProvider>
          <CartProvider>
            <PromotionProvider>
              <PageViewTracker />
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/order" element={<OrderPage />} />
                <Route path="/choose-your-door" element={<ChooseDoorPage />} />
                <Route path="/lookup" element={<OrderLookupPage />} />
                <Route path="/m/:orderId" element={<MeasurementEntryPage />} />
                <Route path="/r/:orderId" element={<ResumeOrderPage />} />
                <Route path="/manage/:orderId" element={<ManageOrderPage />} />
                <Route path="/parts" element={<PartsCatalogPage />} />
                <Route path="/parts/cart" element={<PartsCartPage />} />
                <Route path="/parts/thank-you" element={<PartsThankYouPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/orders" element={<AdminOrders />} />
                <Route path="/admin/products" element={<AdminProducts />} />
                <Route path="/admin/catalog" element={<AdminCatalog />} />
                <Route path="/admin/messages" element={<AdminMessages />} />
                <Route path="/admin/templates" element={<AdminTemplates />} />
                <Route path="/admin/discounts" element={<AdminDiscounts />} />
                <Route path="/admin/promotions" element={<AdminPromotions />} />
                <Route path="/admin/gallery" element={<AdminGallery />} />
              </Routes>
            </PromotionProvider>
          </CartProvider>
        </OrderProvider>
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
